"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
const react_1 = __importDefault(require("react"));
const customize_view_list_item_component_1 = require("./customize-view-list-item.component");
const ListRow = ({ index, style, data }) => {
    const { items, checkedStatus, itemHeight } = data, itemProps = __rest(data, ["items", "checkedStatus", "itemHeight"]);
    const item = items[index];
    const isChecked = checkedStatus[index];
    return (react_1.default.createElement("div", { style: style }, react_1.default.createElement(customize_view_list_item_component_1.CustomizeViewListItem, Object.assign({ item: item, index: index, isChecked: isChecked, itemHeight: itemHeight }, itemProps))));
};
exports.ListRow = ListRow;
